export default __webpack_public_path__ + "static/media/5.81c7e58a.jpg";